
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('¡Hola! Me interesa obtener más información sobre sus servicios de marketing digital con IA. ¿Podrían ayudarme?');
    window.open(`https://wa.me/34685340545?text=${message}`, '_blank');
  };

  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({ 
      behavior: 'smooth' 
    });
  };

  return (
    <section 
      id="inicio" 
      className="relative min-h-screen flex items-center"
    >
      {/* Imagen de fondo */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/7de5d719fcdb40a4bb90cf78ce0ac9df.jpg')`
        }}
      />
      
      {/* Overlay con gradiente más fuerte */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent" />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Contenido de texto - lado izquierdo */}
          <div className="w-full">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Marketing Digital
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">
                Potenciado por IA
              </span>
            </h1>
            <p className="text-xl text-gray-100 mb-8 max-w-2xl">
              Revoluciona tu negocio con estrategias de marketing digital inteligentes. 
              Combinamos experiencia humana con el poder de la inteligencia artificial 
              para obtener resultados extraordinarios.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button size="lg" className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 whitespace-nowrap" onClick={scrollToContact}>
                <i className="ri-rocket-line mr-2"></i>
                Comenzar Ahora
              </Button>
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white hover:text-gray-900 whitespace-nowrap" onClick={handleWhatsAppClick}>
                <i className="ri-whatsapp-line mr-2"></i>
                Consulta por WhatsApp
              </Button>
            </div>
            
            <div className="flex items-center space-x-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-white">500+</div>
                <div className="text-gray-200 text-sm">Clientes Satisfechos</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-white">250%</div>
                <div className="text-gray-200 text-sm">ROI Promedio</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-white">24/7</div>
                <div className="text-gray-200 text-sm">Automatización IA</div>
              </div>
            </div>
          </div>
          
          {/* Espacio para la imagen - lado derecho */}
          <div className="hidden lg:block">
            {/* Este espacio permite que la imagen de fondo se vea mejor */}
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
